export class Event {
  public id_evt?: number = -1;
  public uuid_evt: string = "";
  public date_creation: number[] = new Array();
  public date_debut: number[] = new Array();
  public date_fin: number[] = new Array();
  public date_modification: number[] = new Array();

  public designation: string = "";
  public flag_appro: string = "NEW";
  public source: string = "LOC";

  public flag_suppression: boolean = false;
  public id_hierarchie: string = "";

  public couleur: string = "#fdd835";
  public version: number = 0;
  public utilisateur_creation: string = "";
  public utilisateur_modification: string = "";

  public $fullDay?: boolean = true;

  public tauxImpact: number = 0;
  public typeImpact: string = "";

  constructor() {
    //
  }
}

export class Canal {
  public id_canvente: string = "";
  public niv_canvente: number = -1;
  public designation_canvente: string = "";
  public id_canvente_parent: string = "";
}

export class Plu {
  public id_pluprev: string = "";
  public niv_pluprev: number = -1;
  public designation_pluprev: string = "";
  public id_pluprev_parent: string = "";
}

export class Hierarchie {
  public id_hierarchie: string = "";
  public designation_hierarchie: string = "";
  public niveau: number = 0;
  public id_hierarchie_parent: string = "";
  public attribut_ekimetrics?: string = "";
  public attribut_fmcouleur?: string = "";
  public attribut_fmcategorie?: string = "";
}

export class PerimAffects {
  public uuid_affect: string = "";
  public uuid_evt: string = "";
  public type: string = "CAN" || "RES" || "PLU";
  public valeur: string = "";
  public flag_suppression: boolean = false;
}

export class Collab {
  public main_evenements?: Event[] = new Array();
  public perim_affects: PerimAffects[] = new Array();

  public perim_plus: Plu[] = new Array();
  public perim_canaux: Canal[] = new Array();
  public param_hierarchies: Hierarchie[] = new Array();

  constructor(event: Event, perimAffects: PerimAffects[]) {
    this.main_evenements = new Array();
    this.main_evenements.push(event);
    this.perim_affects = perimAffects;
  }

  public emptyEvent() {
    this.main_evenements = undefined;
  }

  public makeEvent() {
    this.main_evenements = new Array();
  }
}
